import styled, { css } from 'styled-components';
import colors from '../colors';
import { baseTyping } from '../typings';
import { Theme } from 'react-select';

interface PropsI {
  error?: boolean;
  isDisabled?: boolean;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const theme = (theme: Theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#02BF8E',
    primary25: '#02BF8E25',
    neutral0: '#F0F1F2',
    neutral20: '#D4D5D8',
    neutral30: '#858A97',
  },
});

export const customStyles = {
  indicatorSeparator: (): React.CSSProperties => ({
    display: 'block',
  }),
  control: (
    provided: React.CSSProperties,
    state: React.ComponentState
  ): React.CSSProperties => {
    return {
      ...provided,
      minHeight: 40,
      borderRadius: 8,
      borderColor: state.isFocused
        ? '#02BF8E'
        : state.selectProps.error
        ? '#ff0000'
        : '#D4D5D8',
      boxShadow: state.isFocused
        ? '0 0 0 1px #02BF8E'
        : state.selectProps.error
        ? '0 0 0 1px #ff0000'
        : '0',
      transition: '0',
      fontFamily: 'futura-pt, sans-serif',
      color: colors.black,
      fontWeight: 450,
      padding: '0px 0px 0px 8px',
    };
  },
  option: (provided: React.CSSProperties): React.CSSProperties => ({
    ...provided,
    fontFamily: 'futura-pt, sans-serif',
    color: colors.black,
    fontWeight: 450,
  }),
};

export const Label = styled.p<PropsI>`
  ${baseTyping}

  font-size: 14px;
  line-height: 24px;
  margin: 0px 0px 0px 17px;
  color: ${(props) =>
    props.error
      ? colors.red
      : props.isDisabled
      ? colors.grey
      : colors.black} !important;
`;

export const ErrorLabel = styled(Label)`
  font-size: 12px;
  line-height: 16px;
`;

interface ContainerPropsI {
  fixedWidth?: number;
  isDisabled?: boolean;
}

const disabledSelectStyles = css`
  border: 1.5px solid ${colors.grey};
  background-color: ${colors.lightGrey};
  color: ${colors.grey}!important;
`;

export const Container = styled.div<ContainerPropsI>`
  min-width: 200px;
  width: ${(props) => (props.fixedWidth ? `${props.fixedWidth}px` : '100%')};

  & > div[class*='-container'] > div[class*='-control'] {
    ${(props) => props.isDisabled && disabledSelectStyles}
  }
`;

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  & svg {
    width: 20px;
    height: 20px;
    margin-right: 15px;
  }
`;

export const BoldSpan = styled.span`
  font-weight: 450;
`;

export const ThinSpan = styled.span`
  font-weight: 300;
`;
